module.exports = XMLHttpRequest;


//////////////////
// WEBPACK FOOTER
// external "XMLHttpRequest"
// module id = 19
// module chunks = 0